module.exports = __webpack_public_path__ + "static/media/120-600.51cf18cf.gif";